import { useEffect, useState, useCallback } from "react";
import Popup from "../../popup/Popup";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Loading from "../Loading/Loading";
import CardGameLoader from "../cardGameLoader/CardGameLoader";
import useHandleGameClick from "../useHandleGameClick/useHandleGameClick";

const FindGames = (props) => {
  const [loginforLunchLobby, setLoginforLunchLobby] = useState(false);
  const [isCardLoading, setIsCardLoading] = useState(true);
  const [clickedGame, setClickedGame] = useState(null);
  const [launchGameDetails, setLaunchGameDetails] = useState({});
  const deviceType = localStorage.getItem("device_type");
  const {
    apiResponseError,
    maintainanceError,
    commingSoonPopup,
    isgameplayerPopup,
    gameLaunchMessage,
    handlePopup,
    userDataHandle,
    HandleGamePlayer,
    confirmRelaunch,
    cancelRelaunch,
    ConfirmLanchGamePopup
  } = useHandleGameClick(props, setIsCardLoading, setClickedGame, launchGameDetails);
  const ftpPath = props.findGames.ftp_path ?? null;
  useEffect(() => {
    delete props.findGames.ftp_path;
  }, [props.findGames]);

  const handleGameClick = useCallback((game) => {
    ConfirmLanchGamePopup(game);
    setLaunchGameDetails(game);
  }, [ConfirmLanchGamePopup]);

  const renderGame = useCallback((v, i) => (
    <div
      key={i}
      onClick={() => handleGameClick(v)}
      className="findgames-box"
    >
      {v.maintenance_mode && (
        <div className="undermaintenance">
          {props.t("under_maintanance")}
        </div>
      )}
      <div className="relative">
        <img
          loading="lazy"
          className="find-img"
          src={
            v.game_assets_media
              ? `${v.ftp_path}${v.game_assets_media.base_path}${v.game_assets_media.system_file_name}`
              : `../assets/images/default-images/game.webp`
          }
          alt={v.name}
        />
      </div>
      <a href="#">
        <div className="text-game">
          <div className="find-text">
            {v.name.length > 15 ? (
              <>
                <marquee scrollamount="3">
                  {/* {v.name} */}
                  <h6 className="hovering game-title text-game_name">{v.name}</h6>
                </marquee>
              </>
            ) : (
              <h6 className="hovering game-title text-game_name">{v.name}</h6>
            )}
            {v.tenant_provider_reco?.provider_name !== 'HKB Seamless Gaming' &&
              <p className="game-subtitle text-categories_game_count">
                {v.sub_provider_id && v.sub_provider ? v.sub_provider.alias : v.tenant_provider_reco?.provider_name}
              </p>
            }
          </div>
        </div>
      </a>
      {isCardLoading && clickedGame === v?._id && <CardGameLoader />}
    </div>
  ), [ftpPath, deviceType, handleGameClick, isCardLoading, clickedGame]);

  return (
    <>
      {Object.values(props.findGames).length > 0 ? (
        Object.values(props.findGames).map(renderGame)
      ) : (
        !props.loader && <p>{props.t("game_not_found")}.</p>
      )}
      {props.loader && <Loading />}
      {maintainanceError && <Popup handlePoup={handlePopup} providerMaintainance />}
      {commingSoonPopup && <Popup handlePoup={handlePopup} commingSoonGame />}
      {loginforLunchLobby && <Popup handlePoup={handlePopup} gameLunchLoginErrorPopup />}
      {isgameplayerPopup && (
        <Popup handlePoup={HandleGamePlayer} playerstatus userDataHandle={userDataHandle} />
      )}
      {gameLaunchMessage && (
        <Popup handlePoup={handlePopup} launchGameMessage confirmRelaunch={confirmRelaunch} cancelRelaunch={cancelRelaunch} />
      )}
      {apiResponseError && <Popup handlePoup={handlePopup} apiresponseerror />}
    </>
  );
};

FindGames.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(FindGames);
